import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginRightImageInfo } from './PluginRightImageInfo';
import { PluginRightImageInfoContent } from './PluginRightImageInfoContent';
import { PluginRightImageInfoFigure } from './PluginRightImageInfoFigure';

type Props = {
  index: number;
  data: PluginRightImageInfo;
  updateData: (element: IElement, index: number) => void;
};

export const PluginRightImageInfoFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginRightImageInfo>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-right-image-info">
          <div className="showcase">
            <PluginRightImageInfoContent data={data} update={update} />
            <PluginRightImageInfoFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
